export default {"src":"/polygon/_next/static/media/bannerImage.5f699d6d.svg","height":400,"width":401};